import { render, staticRenderFns } from "./Sadt.vue?vue&type=template&id=22441e5c"
import script from "./Sadt.vue?vue&type=script&lang=js"
export * from "./Sadt.vue?vue&type=script&lang=js"
import style0 from "./Sadt.vue?vue&type=style&index=0&id=22441e5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports